import { render, staticRenderFns } from "./MbPathDetailsModal.vue?vue&type=template&id=1d5a4b38&"
import script from "./MbPathDetailsModal.vue?vue&type=script&lang=js&"
export * from "./MbPathDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports